// extracted by mini-css-extract-plugin
export default {"section":"extraColSection_section__AVi9U","sectionName":"extraColSection_sectionName__0Lcqd","opened":"extraColSection_opened__Xvf++","label":"extraColSection_label__omFyJ"};